module.exports = __webpack_public_path__ + "static/media/sigaassetas.3d7b05d4.mp4";